import { render, staticRenderFns } from "./VisitDetails.vue?vue&type=template&id=605bc730&scoped=true&"
import script from "./VisitDetails.vue?vue&type=script&lang=js&"
export * from "./VisitDetails.vue?vue&type=script&lang=js&"
import style0 from "./VisitDetails.vue?vue&type=style&index=0&id=605bc730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605bc730",
  null
  
)

export default component.exports